import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import type { FormikProps } from 'formik';
import type { IRegisterFormValues } from '../register-form/Register';

interface IMarketingConsentsProps {
  formikProps: FormikProps<IRegisterFormValues>;
}

const MarketingConsents: React.FC<IMarketingConsentsProps> = ({ formikProps }) => {
  const { values, handleChange, handleBlur, errors, touched } = formikProps;

  return (
    <div data-testid="marketing-consents">
      <p>
        <em>
          At TransPennine Express we want you to have access to special offers, exclusive
          competitions and the best travel tips. Sound good?
        </em>
      </p>
      <Form.Group>
        <legend>Yes, keep me in the loop by:</legend>
        <Form.Check
          type="checkbox"
          id="emailMarketing"
          name="emailMarketing"
          label="Email"
          onChange={handleChange}
          onBlur={handleBlur}
        />
        <Form.Check
          type="checkbox"
          id="pushMarketing"
          name="pushMarketing"
          label="App push"
          onChange={handleChange}
          onBlur={handleBlur}
        />
        <Form.Check
          type="checkbox"
          id="smsMarketing"
          name="smsMarketing"
          label="SMS"
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {values.smsMarketing && (
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3" controlId="email">
                <Form.Label>Phone *</Form.Label>
                <Form.Control
                  type="phoneNumber"
                  name="phoneNumber"
                  placeholder="Phone"
                  aria-describedby="phone-error-message"
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                <Form.Text id="phone-error-message" role="alert" className="form-text">
                  {errors.phoneNumber && touched.phoneNumber && errors.phoneNumber}
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>
        )}
      </Form.Group>

      <Form.Group className="register-form__age-confirmation__block">
        <p>
          <em>
            Please confirm your age. Note, no marketing communications will be sent to under 16s, if
            you have selected to hear from us:
          </em>
        </p>
        <legend>Please confirm your age:</legend>
        <Form.Check
          type="radio"
          id="over16-yes"
          name="isOver16"
          value="on"
          label="I am over 16"
          checked={values.isOver16 === 'on'}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        <Form.Check
          type="radio"
          id="over16-no"
          name="isOver16"
          value="off"
          label="I am under 16"
          checked={values.isOver16 === 'off'}
          onChange={handleChange}
          onBlur={handleBlur}
        />
      </Form.Group>
    </div>
  );
};

export default MarketingConsents;
